import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const VerticalEmbed = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_verticalEmbed_lazy" */
    "./vertical-embed.js"
  )
);
const VerticalEmbedRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    VerticalEmbed,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const VerticalEmbedLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(VerticalEmbedRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.APP_EMBED]: VerticalEmbedLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
